import { render, staticRenderFns } from "./RiskProfileForm.vue?vue&type=template&id=3f12859a"
import script from "./RiskProfileForm.vue?vue&type=script&lang=js"
export * from "./RiskProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports